/*jshint esversion: 6 */

import React from 'react';
import moment from 'moment';

const intervalTick = 50;

class CaTimer extends React.Component {

    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.timer = setInterval(this.tick.bind(this), intervalTick);
    }

    tick() {

        if (this.props.timeLeft <= intervalTick) {
            clearInterval(this.timer);
        }

        this.props.onTick();

    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    formatTime(ms) {
        const duration = moment.duration(ms);
        return moment.utc(duration.asMilliseconds()).format("mm:ss");
    }

    render(){
        return(
            <div className={"QuizTimer"}>
                <span className={"QuizTimer__text"}>{this.formatTime(this.props.timeLeft)}</span>
            </div>
        )
    }
}
export default CaTimer;
